(function (window) {
  "use strict";

  // =============================================
  // ユーティリティ関数
  // =============================================

  function $(selector, context) {
    return (context || document).querySelector(selector);
  }
  function $$(selector, context) {
    return Array.from((context || document).querySelectorAll(selector));
  }
  function on(el, events, handler) {
    if (!el) return;
    events.split(' ').forEach(function (e) {
      el.addEventListener(e, handler);
    });
  }
  function onAll(selector, events, handler, context) {
    $$(selector, context).forEach(function (el) {
      on(el, events, handler);
    });
  }
  // イベント委譲
  function delegate(parentSelector, childSelector, event, handler) {
    on(document.body, event, function (e) {
      var target = e.target.closest(childSelector);
      if (target && document.body.contains(target)) {
        handler.call(target, e);
      }
    });
  }

  function hide(el) {
    if (el) el.style.display = 'none';
  }
  function show(el, display) {
    if (el) el.style.display = display || '';
  }
  function toggle(el) {
    if (!el) return;
    if (el.style.display === 'none' || getComputedStyle(el).display === 'none') {
      show(el);
    } else {
      hide(el);
    }
  }
  function hideAll(selector, ctx) {
    $$(selector, ctx).forEach(hide);
  }
  function showAll(selector, ctx) {
    $$(selector, ctx).forEach(show);
  }

  function fadeIn(el, duration, callback) {
    if (!el || el._fadingIn) return;
    if (el.style.display !== 'none' && getComputedStyle(el).display !== 'none' && parseFloat(getComputedStyle(el).opacity) === 1) return;
    duration = duration || 400;
    if (el._fadeId) { cancelAnimationFrame(el._fadeId); el._fadeId = null; }
    el._fadingIn = true; el._fadingOut = false;
    el.style.display = '';
    if (getComputedStyle(el).display === 'none') el.style.display = 'block';
    var startOp = parseFloat(getComputedStyle(el).opacity) || 0;
    el.style.opacity = startOp;
    var remaining = (1 - startOp) * duration;
    if (remaining <= 0) { el.style.opacity = 1; el._fadingIn = false; if (callback) callback(); return; }
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / remaining, 1);
      el.style.opacity = startOp + (1 - startOp) * p;
      if (p < 1) { el._fadeId = requestAnimationFrame(step); }
      else { el.style.opacity = 1; el._fadingIn = false; el._fadeId = null; if (callback) callback(); }
    }
    el._fadeId = requestAnimationFrame(step);
  }

  function fadeOut(el, duration, callback) {
    if (!el || el._fadingOut) return;
    if (el.style.display === 'none' || getComputedStyle(el).display === 'none') return;
    duration = duration || 400;
    if (el._fadeId) { cancelAnimationFrame(el._fadeId); el._fadeId = null; }
    el._fadingOut = true; el._fadingIn = false;
    var startOp = parseFloat(getComputedStyle(el).opacity);
    if (isNaN(startOp)) startOp = 1;
    var remaining = startOp * duration;
    if (remaining <= 0) { el.style.display = 'none'; el.style.opacity = 0; el._fadingOut = false; if (callback) callback(); return; }
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / remaining, 1);
      el.style.opacity = startOp * (1 - p);
      if (p < 1) { el._fadeId = requestAnimationFrame(step); }
      else { el.style.display = 'none'; el.style.opacity = 0; el._fadingOut = false; el._fadeId = null; if (callback) callback(); }
    }
    el._fadeId = requestAnimationFrame(step);
  }

  function animateScrollTop(target, duration) {
    duration = duration || 400;
    var startPos = window.pageYOffset;
    var diff = target - startPos;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      window.scrollTo(0, startPos + diff * p);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function hasClass(el, cls) { return el && el.classList.contains(cls); }
  function addClass(el, cls) { if (el) el.classList.add(cls); }
  function removeClass(el, cls) { if (el) el.classList.remove(cls); }
  function toggleClass(el, cls) { if (el) el.classList.toggle(cls); }

  function getIndex(el) {
    return Array.from(el.parentNode.children).indexOf(el);
  }

  function outerHeight(el) { return el ? el.offsetHeight : 0; }
  function outerWidth(el) { return el ? el.offsetWidth : 0; }
  function offsetTop(el) {
    if (!el) return 0;
    return el.getBoundingClientRect().top + window.pageYOffset;
  }

  // =============================================
  // デバイス判定
  // =============================================
  var ua = navigator.userAgent;
  var isSmartDevice = ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0;
  var isTabletDevice = navigator.platform === "iPad" ||
    (navigator.platform === "MacIntel" && ua.indexOf("Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Firefox") === -1 && navigator.standalone !== undefined);

  // =============================================
  // ヘッダー デバイス別
  // =============================================
  if (isSmartDevice) {
    // スマホ: 特になし
  } else if (isTabletDevice) {
    onAll('.block-header--default-menu-list-item-name', 'touchstart', function () {
      hideAll('.block-header--search');
      hideAll('.block-header--search-container');
      var parent = this.closest('.block-header--default-menu-list-item');
      if (hasClass(parent, 'block-header--default-menu-list-item__active')) {
        removeClass(parent, 'block-header--default-menu-list-item__active');
      } else {
        $$('.block-header--default-menu-list-item').forEach(function (item) {
          removeClass(item, 'block-header--default-menu-list-item__active');
        });
        addClass(parent, 'block-header--default-menu-list-item__active');
      }
    });
  } else {
    onAll('.block-header--default-menu-list-item', 'mouseover', function () {
      addClass(this, 'block-header--default-menu-list-item__active');
      hideAll('.block-header--search');
      hideAll('.block-header--search-container');
    });
    onAll('.block-header--default-menu-list-item', 'mouseout', function () {
      removeClass(this, 'block-header--default-menu-list-item__active');
    });
  }

  // =============================================
  // DOMContentLoaded
  // =============================================
  document.addEventListener('DOMContentLoaded', function () {

    // --- ヘッダー共通 ---
    onAll('.block-header--hamburger-menu-open', 'click', function () {
      addClass($('.block-header--hamburger-menu'), 'block-header--hamburger-menu__active');
    });
    onAll('.block-header--hamburger-menu-close', 'click', function () {
      removeClass($('.block-header--hamburger-menu'), 'block-header--hamburger-menu__active');
    });
    onAll('.block-header--hamburger-menu-list-item-name', 'click', function () {
      toggleClass(this.parentElement, 'block-header--hamburger-menu-list-item__active');
    });
    onAll('.block-header--hamburger-menu-sub-menu-list-item-name', 'click', function () {
      toggleClass(this.parentElement, 'block-header--hamburger-menu-sub-menu-list-item__active');
    });
    onAll('.block-header--important-announce-close', 'click', function () {
      hide($('.block-header--important-announce'));
    });
    onAll('.block-header--icon-menu-search-button', 'click', function () {
      toggle($('.block-header--search'));
      toggle($('.block-header--search-container'));
      var input = $('.block-header--search-input');
      if (input) input.focus();
    });

    // --- フッター ---
    onAll('.block-footer--return', 'click', function (e) {
      e.preventDefault();
      animateScrollTop(0, 500);
    });

    // --- ページ判定 ---
    var body = document.body;
    if (hasClass(body, 'page-product')) {
      pageProductSet();
    } else if (hasClass(body, 'page-list')) {
      pageListSet();
    } else if (hasClass(body, 'page-information')) {
      pageInformationSet();
    } else if (hasClass(body, 'page-ranking')) {
      pageRankingSet();
    } else if (hasClass(body, 'page-cart')) {
      orderMenuSet();
    } else if (hasClass(body, 'page-order')) {
      pageOrderSet();
      orderMenuSet();
    } else if (hasClass(body, 'page-order-confirmation')) {
      pageOrderConfirmationSet();
      orderMenuSet();
    } else if (hasClass(body, 'page-license-check')) {
      pageLicenseCheckSet();
    }

    pageLiposomeSet();
    snsShareLinkSet();
    tabChangeSet();
    accordionSet();
    moreViewSet();
    narrowDownSet();
    pageScrollLinkSet();
    checkBoxSet();
    spinButtonSet();
    modalSetRe();
  });

  // =============================================
  // window load
  // =============================================
  window.addEventListener('load', function () {
    // ※ slick はjQueryプラグインのため、Splide / Swiper 等に置き換えが必要です。
    // 以下はコメントで slick 初期化相当の設定を残しています。
    //
    // initSlider('.js-slick', { autoplay:true, dots:true, arrows:true, speed:1000 });
    // initSlider('.js-slick-fade', { autoplay:true, fade:true, arrows:false, speed:1000 });
    // initSlider('.js-slick-manual', { autoplay:false, dots:true, arrows:true, speed:1000 });
    // initSlider('.js-slick__two-slides', { autoplay:true, dots:true, arrows:true, slidesToShow:2, slidesToScroll:2, speed:1000 });
    // initSlider('.js-slick__two-slides-manual', { autoplay:false, dots:true, arrows:true, slidesToShow:2, slidesToScroll:2, speed:1000 });
    // initSlider('.js-slick__three-slides-manual', { autoplay:false, dots:true, arrows:true, slidesToShow:3, slidesToScroll:3, speed:1000 });
    // initSlider('.js-slick__five-slides-manual', { autoplay:false, dots:true, arrows:true, slidesToShow:5, slidesToScroll:5, speed:1000 });
    // initSlider('.js-slick__six-slides-manual', { autoplay:false, dots:true, arrows:true, slidesToShow:6, slidesToScroll:6, speed:1000 });
  });

  // =============================================
  // window scroll
  // =============================================
  window.addEventListener('scroll', function () {
    var header = $('.block-header');
    if (!header) return;
    if (window.pageYOffset > 200) {
      addClass(header, 'block-header__short');
    } else {
      removeClass(header, 'block-header__short');
    }
  });

  // =============================================
  // スピンボタン
  // =============================================
  function spinButtonSet() {
    $$('.common-input-number').forEach(function (wrapper) {
      var up = document.createElement('span');
      up.className = 'common-input-number--up';
      up.textContent = 'up';
      var down = document.createElement('span');
      down.className = 'common-input-number--down';
      down.textContent = 'down';
      wrapper.appendChild(up);
      wrapper.appendChild(down);

      on(up, 'click', function () {
        var input = wrapper.querySelector('input[type="number"]');
        if (input) input.value = Number(input.value) + 1;
      });
      on(down, 'click', function () {
        var input = wrapper.querySelector('input[type="number"]');
        if (input) {
          var num = Number(input.value);
          if (num > 1) input.value = num - 1;
        }
      });
    });
  }

  // =============================================
  // モーダル表示 改修版
  // =============================================
  function modalSetRe() {
    var target, targetBox, targetCloseButton, targetCheckBox, targetRadioButton;

    function boxSizeSet() {
      var wh = outerHeight(target);
      var bh = outerHeight(targetBox);
      var ww = outerWidth(target);
      var bw = outerWidth(targetBox);
      targetBox.style.top = ((wh - bh) / 2) + 'px';
      targetBox.style.left = ((ww - bw) / 2) + 'px';
    }
    function modalClose() {
      fadeOut(target, 200, function () {
        // unwrap: main-container の中身を親に戻す
        if (targetBox && targetBox.parentNode) {
          while (targetBox.firstChild) {
            targetBox.parentNode.insertBefore(targetBox.firstChild, targetBox);
          }
          targetBox.parentNode.removeChild(targetBox);
        }
        if (targetCloseButton && targetCloseButton.parentNode) {
          targetCloseButton.parentNode.removeChild(targetCloseButton);
        }
        if (targetCheckBox) targetCheckBox.forEach(function (cb) { cb.checked = false; });
        if (targetRadioButton) targetRadioButton.forEach(function (rb) { rb.checked = false; });
      });
    }

    hideAll('.js-modal-window');

    delegate('body', '.js-modal-trigger', 'click', function (e) {
      e.preventDefault();
      var name = this.getAttribute('data-target');
      target = $('.js-modal-window.' + name);
      if (!target) return;

      // wrapInner
      var container = document.createElement('div');
      container.className = 'js-modal-window--main-container';
      while (target.firstChild) { container.appendChild(target.firstChild); }
      target.appendChild(container);

      var closeBtn = document.createElement('div');
      closeBtn.className = 'js-modal-window--close-button js-modal-window--close-trigger';
      closeBtn.textContent = 'close';
      container.appendChild(closeBtn);

      targetBox = container;
      targetCloseButton = closeBtn;
      targetCheckBox = $$('input[type="checkbox"]', targetBox);
      targetRadioButton = $$('input[type="radio"]', targetBox);

      fadeIn(target, 400);
      boxSizeSet();

      on(window, 'resize', boxSizeSet);
      on(target, 'click', function () { modalClose(); });
      on(closeBtn, 'click', function () { modalClose(); });
      on(targetBox, 'click', function (ev) { ev.stopPropagation(); });
    });
  }

  // =============================================
  // 共通ラジオボタン
  // =============================================
  function checkBoxSet() {
    onAll('.common-input-radio-label', 'click', function () {
      var check = this.querySelector('.common-input-radio');
      if (!check) return;
      if (check.checked) {
        check.checked = false;
        removeClass(this, 'common-input-radio-label__active');
      } else {
        check.checked = true;
        addClass(this, 'common-input-radio-label__active');
      }
    });
  }

  // =============================================
  // 共通アコーディオン
  // =============================================
  function accordionSet() {
    onAll('.js-accordion-trigger', 'click', function () {
      toggleClass(this, 'js-accordion-trigger__active');
      var container = this.nextElementSibling;
      if (container && hasClass(container, 'js-accordion-container')) {
        toggle(container);
      }
    });
  }

  // =============================================
  // 共通もっと見る
  // =============================================
  function moreViewSet() {
    onAll('.js-more-view-trigger', 'click', function () {
      var target = this.getAttribute('data-target');
      toggleClass(this, 'js-more-view-trigger__active');
      $$('.js-more-view-container.' + target).forEach(toggle);
    });
  }

  // =============================================
  // 共通絞り込み(select利用)
  // =============================================
  function narrowDownSet() {
    var selectEl = $('.js-narrow-down-select');
    if (!selectEl) return;
    var target = selectEl.getAttribute('data-target');
    on(selectEl, 'change', function () {
      var val = this.options[this.selectedIndex].value;
      var container = $('.js-narrow-down-target-container.' + target);
      if (!container) return;
      Array.from(container.children).forEach(hide);
      $$(('.' + val), container).forEach(show);
    });
  }

  // =============================================
  // 共通ページ内リンクスクロール
  // =============================================
  function pageScrollLinkSet() {
    onAll('.js-page-scroll', 'click', function (e) {
      e.preventDefault();
      var target = this.getAttribute('data-target');
      var el = $('.' + target);
      if (el) animateScrollTop(offsetTop(el) - 150, 400);
    });
  }

  // =============================================
  // 共通タブ切り替え
  // =============================================
  function tabChangeSet() {
    $$('.js-tab-area').forEach(function (area) {
      Array.from(area.children).forEach(function (child) {
        if (!hasClass(child, 'js-tab-area--item__active')) hide(child);
      });
    });
    $$('.js-tab').forEach(function (tabWrap) {
      Array.from(tabWrap.children).forEach(function (tab) {
        on(tab, 'click', function () {
          var name = tabWrap.getAttribute('data-target');
          var area = $('.js-tab-area.' + name);
          if (!area) return;
          var targets = Array.from(area.children);
          var tabs = Array.from(tabWrap.children);
          var index = tabs.indexOf(this);

          tabs.forEach(function (t) { removeClass(t, 'js-tab--item__active'); });
          addClass(this, 'js-tab--item__active');

          targets.forEach(function (t) {
            hide(t);
            removeClass(t, 'js-tab-area--item__active');
          });
          if (targets[index]) {
            show(targets[index]);
            addClass(targets[index], 'js-tab-area--item__active');
          }
          // slick 相当の処理が必要な場合はここでスライダー再初期化
        });
      });
    });
  }

  // =============================================
  // 共通シェアリンク設定
  // =============================================
  function snsShareLinkSet() {
    var thisUrl = location.href;
    var encodeUrl = encodeURIComponent(thisUrl);
    var fb = $('.block-header--icon-menu-list-item-anchor__facebook');
    var tw = $('.block-header--icon-menu-list-item-anchor__twitter');
    var line = $('.block-header--icon-menu-list-item-anchor__line');
    if (fb) fb.href = 'https://www.facebook.com/share.php?u=' + thisUrl;
    if (tw) tw.href = 'https://twitter.com/share?url=' + thisUrl;
    if (line) line.href = 'https://social-plugins.line.me/lineit/share?url=' + encodeUrl;
  }

  // =============================================
  // page-information
  // =============================================
  function pageInformationSet() {
    function scrollTo(triggerSel, targetSel) {
      onAll(triggerSel, 'click', function (e) {
        e.preventDefault();
        var el = $(targetSel);
        if (el) animateScrollTop(offsetTop(el) - 150, 400);
      });
    }
    scrollTo('.block-news-nav--list-item__product', '.block-news--product');
    scrollTo('.block-news-nav--list-item__campaign', '.block-news--campaign');
    scrollTo('.block-news-nav--list-item__information', '.block-news--information');

    var p = $('.block-news--product'); if (p) p.id = 'product';
    var c = $('.block-news--campaign'); if (c) c.id = 'campaign';
    var i = $('.block-news--information'); if (i) i.id = 'information';
  }

  // =============================================
  // page-ranking
  // =============================================
  function pageRankingSet() {
    function scrollTo(triggerSel, targetSel) {
      onAll(triggerSel, 'click', function (e) {
        e.preventDefault();
        var el = $(targetSel);
        if (el) animateScrollTop(offsetTop(el) - 150, 400);
      });
    }
    scrollTo('.block-ranking-nav--list-item__skincare', '.block-ranking__skincare');
    scrollTo('.block-ranking-nav--list-item__basemake', '.block-ranking__basemake');
    scrollTo('.block-ranking-nav--list-item__pointmake', '.block-ranking__pointmake');
  }

  // =============================================
  // page-liposome
  // =============================================
  function pageLiposomeSet() {
    function scrollTo(triggerSel, targetSel) {
      onAll(triggerSel, 'click', function (e) {
        e.preventDefault();
        var el = $(targetSel);
        if (el) animateScrollTop(offsetTop(el) - 150, 400);
      });
    }
    scrollTo('.block-line--page-nav-item__concept', '.block-line--concept-detail');
    scrollTo('.block-line--page-nav-item__review', '.block-line--review');
    scrollTo('.block-line--page-nav-item__products', '.block-list');
  }

  // =============================================
  // page-list
  // =============================================
  function pageListSet() {

    // 一覧表示形式変更
    (function listFormatSet() {
      var listBtn = $('.block-list--list-format-list-button');
      var gridBtn = $('.block-list--list-format-grid-button');
      var list = $('.block-list--list-frame');
      if (!list) return;
      on(listBtn, 'click', function () {
        addClass(this, 'block-list--list-format-list-button__active');
        removeClass(gridBtn, 'block-list--list-format-grid-button__active');
        addClass(list, 'block-list--list-frame__list');
        removeClass(list, 'block-list--list-frame__grid');
      });
      on(gridBtn, 'click', function () {
        addClass(this, 'block-list--list-format-grid-button__active');
        removeClass(listBtn, 'block-list--list-format-list-button__active');
        addClass(list, 'block-list--list-frame__grid');
        removeClass(list, 'block-list--list-frame__list');
      });
    })();

    // 絞り込みメニューアコーディオン
    (function narrowDownMenuSet() {
      onAll('.block-list--list-narrow-down', 'click', function () {
        toggleClass(this, 'block-list--list-narrow-down__active');
        var next = this.nextElementSibling;
        if (next && hasClass(next, 'block-list--list-narrow-down-menu')) toggle(next);
      });
      onAll('.block-list--list-narrow-down-menu-reset-button', 'click', function () {
        $$('.block-list--list-narrow-down-menu-narrow-radio-list-item-button').forEach(function (cb) { cb.checked = false; });
      });
    })();

    // 絞り込みメニューボタン固定
    (function narrowDownMenuButtonSet() {
      var menu = $('.block-list--list-narrow-down-menu');
      if (!menu) return;
      var btnArea = $('.block-list--list-narrow-down-menu-button-area');
      function positionSet() {
        var menuStart = offsetTop(menu) + 140;
        var menuEnd = offsetTop(menu) + menu.offsetHeight;
        var current = window.pageYOffset + window.innerHeight;
        if (menuStart < current && current < menuEnd) {
          addClass(btnArea, 'block-list--list-narrow-down-menu-button-area__fixed');
        } else {
          removeClass(btnArea, 'block-list--list-narrow-down-menu-button-area__fixed');
        }
      }
      on(window, 'scroll', positionSet);
      onAll('.js-accordion-trigger', 'click', function () { setTimeout(positionSet, 10); });
    })();

    // その他リンクメニューアコーディオン
    (function otherMenuSet() {
      onAll('.block-list--other-menu-trigger__categroy', 'click', function () {
        toggleClass($('.block-other-menu__category'), 'block-other-menu__active');
      });
      onAll('.block-list--other-menu-trigger__purpose', 'click', function () {
        toggleClass($('.block-other-menu__purpose'), 'block-other-menu__active');
      });
      hideAll('.block-other-menu--sub-link-list');
      onAll('.block-other-menu--link-list-item-name', 'click', function () {
        toggleClass(this, 'block-other-menu--link-list-item-name__active');
        var next = this.nextElementSibling;
        if (next && hasClass(next, 'block-other-menu--sub-link-list')) toggle(next);
      });
      onAll('.block-other-menu--close-trigger', 'click', function () {
        var parent = this.closest('.block-other-menu');
        if (parent) toggleClass(parent, 'block-other-menu__active');
      });
    })();

    // サイドメニューチェックリセット
    onAll('.block-list--side-menu-narrow-reset-button', 'click', function () {
      $$('.block-list--side-menu-narrow-list-item-button').forEach(function (cb) { cb.checked = false; });
    });

    // 色玉変更切り替え
    colorChangeSet();
  }

  // =============================================
  // 色玉変更切り替え（共通）
  // =============================================
  function colorChangeSet() {
    var triggers = $$('.js-change-trigger');
    var targets = $$('.js-change-target');
    function reset() {
      triggers.forEach(function (t) { removeClass(t, 'js-change-trigger__active'); });
      targets.forEach(function (t) { removeClass(t, 'js-change-target__active'); hide(t); });
    }
    targets.forEach(function (t) { hide(t); });
    $$('.js-change-target__active').forEach(show);
    triggers.forEach(function (trigger) {
      on(trigger, 'click', function () {
        var id = this.getAttribute('data-target');
        reset();
        $$('.js-change-trigger[data-target="' + id + '"]').forEach(function (t) { addClass(t, 'js-change-trigger__active'); });
        $$('.js-change-target[data-color-id="' + id + '"]').forEach(function (t) { show(t); addClass(t, 'js-change-target__active'); });
      });
    });
  }

  // =============================================
  // page-product
  // =============================================
  function pageProductSet() {
    // ※ slick スライダー部分は Splide / Swiper 等への置き換えが必要です
    // initSlider('.block-detail--image-thumbnail-list', { ... });
    // initSlider('.block-detail--image-list', { ... });
    // initSlider('.block-detail--color-slide-list', { ... });

    // 色玉変更
    colorChangeSet();

    // サムネイル連動メイン画像変更
    imageChangeSet();

    // 刻印チェックアコーディオン
    onAll('.block-detail--engraved-check > input[type="checkbox"]', 'click', function () {
      var setting = $('.block-detail--engraved-setting');
      if (this.checked) { show(setting); } else { hide(setting); }
    });

    // シェアボタン表示
    onAll('.block-detail--share-button', 'click', function () {
      toggle($('.block-detail--share-list'));
    });

    // 色玉セレクター PC
    (function () {
      var selector = $('.block-detail--color-selector');
      var selectList = $('.block-detail--color-selector-list');
      if (!selector || !selectList) return;
      on(selector, 'mouseleave', function () { hide(selectList); });
      on($('.block-detail--color-selector-current-item'), 'click', function () { toggle(selectList); });
    })();

    // 色玉セレクター SPフロートメニュー
    (function () {
      var selector = $('.block-cart-menu--color-selector');
      var selectList = $('.block-cart-menu--color-selector-list');
      if (!selector || !selectList) return;
      on(selector, 'mouseleave', function () { hide(selectList); });
      on($('.block-cart-menu--color-selector-current-item'), 'click', function () { toggle(selectList); });
      onAll('.block-cart-menu--color-selector-list-item', 'click', function () { toggle(selectList); });
    })();

    // サイズセレクター SPフロートメニュー
    (function () {
      var selector = $('.block-cart-menu--size-selector');
      var selectList = $('.block-cart-menu--size-selector-list');
      if (!selector || !selectList) return;
      on(selector, 'mouseleave', function () { hide(selectList); });
      on($('.block-cart-menu--size-selector-current-item'), 'click', function () { toggle(selectList); });
      onAll('.block-cart-menu--size-selector-list-item', 'click', function () { toggle(selectList); });
    })();

    // SPフロートメニュー位置
    (function () {
      var menu = $('.block-cart-menu');
      if (!menu) return;
      var copyEl = $('.block-detail--copy');
      var menuH = outerHeight(menu);
      var menuStartPos = offsetTop(copyEl) + menuH;
      menu.style.bottom = (-menuH) + 'px';

      var colorList = $('.block-cart-menu--color-selector-list');
      var sizeList = $('.block-cart-menu--size-selector-list');

      on(window, 'scroll', function () {
        var reviewEl = $('.block-review');
        if (!reviewEl) return;
        var menuEndPos = offsetTop(reviewEl) + menuH;
        var currentPos = window.pageYOffset + window.innerHeight;
        if (currentPos < menuStartPos) {
          menu.style.bottom = (-menuH) + 'px';
          hide(colorList); hide(sizeList);
        } else if (menuStartPos < currentPos && currentPos < menuEndPos) {
          menu.style.bottom = '0';
        } else {
          menu.style.bottom = (-menuH) + 'px';
          hide(colorList); hide(sizeList);
        }
      });
    })();
  }

  function imageChangeSet() {
    var activeTarget = $('.js-change-target__active');
    if (!activeTarget) return;
    var thumbnails = $$('.block-detail--image-thumbnail-list-item', activeTarget);
    var mains = $$('.block-detail--image-main-list-item', activeTarget);
    mains.forEach(hide);
    if (mains[0]) show(mains[0]);
    thumbnails.forEach(function (thumb, i) {
      // 古いイベント除去のため clone
      var newThumb = thumb.cloneNode(true);
      thumb.parentNode.replaceChild(newThumb, thumb);
      on(newThumb, 'click', function () {
        mains.forEach(hide);
        if (mains[i]) fadeIn(mains[i], 400);
      });
    });
  }

  // =============================================
  // 注文ページ右メニュー
  // =============================================
  function orderMenuSet() {
    var actionEl = $('.block-action');
    if (!actionEl) return;
    var menu = $('.block-action--container');
    if (!menu) return;
    var menuStartPos = offsetTop(actionEl);

    on(window, 'scroll', function () {
      var menuEndPos = offsetTop(actionEl) + actionEl.offsetHeight - outerHeight(menu);
      var current = window.pageYOffset;
      if (current < (menuStartPos - 99)) {
        menu.style.position = 'relative';
        menu.style.top = '0';
      } else if ((menuStartPos - 100) < current && current < (menuEndPos - 180)) {
        menu.style.position = 'fixed';
        menu.style.top = '100px';
      } else {
        menu.style.position = 'relative';
        menu.style.top = (actionEl.offsetHeight - outerHeight(menu) - 80) + 'px';
      }
    });
  }

  // =============================================
  // page-order
  // =============================================
  function pageOrderSet() {
    wrappingSelectSet();
  }

  function wrappingSelectSet() {
    var target, targetBox, targetCloseButton;
    var sceneFirst, sceneSecond, sceneThird, sceneThirdAll;
    var wrappingMessageSettingArea;

    function boxSizeSet() {
      var wh = outerHeight(target); var bh = outerHeight(targetBox);
      var ww = outerWidth(target); var bw = outerWidth(targetBox);
      targetBox.style.top = ((wh - bh) / 2) + 'px';
      targetBox.style.left = ((ww - bw) / 2) + 'px';
    }
    function modalClose() {
      fadeOut(target, 400, function () {
        if (targetBox && targetBox.parentNode) {
          while (targetBox.firstChild) targetBox.parentNode.insertBefore(targetBox.firstChild, targetBox);
          targetBox.parentNode.removeChild(targetBox);
        }
        if (targetCloseButton && targetCloseButton.parentNode) targetCloseButton.parentNode.removeChild(targetCloseButton);
        hide(sceneFirst); hide(sceneSecond);
        if (sceneSecond) $$('input[type="radio"]', sceneSecond).forEach(function (r) { r.checked = false; });
        hide(sceneThird);
        if (sceneThird) {
          $$('input[type="checkbox"]', sceneThird).forEach(function (c) { c.checked = false; });
          $$('input[type="radio"]', sceneThird).forEach(function (r) { r.checked = false; });
        }
        hide(sceneThirdAll);
        if (sceneThirdAll) {
          $$('input[type="checkbox"]', sceneThirdAll).forEach(function (c) { c.checked = false; });
          $$('input[type="radio"]', sceneThirdAll).forEach(function (r) { r.checked = false; });
        }
        show(wrappingMessageSettingArea);
      });
    }

    hideAll('.js-wrapping-select-window');
    onAll('.js-wrapping-select-trigger', 'click', function (e) {
      e.preventDefault();
      target = $('.js-wrapping-select-window');
      if (!target) return;

      var container = document.createElement('div');
      container.className = 'js-wrapping-select-window--main-container';
      while (target.firstChild) container.appendChild(target.firstChild);
      target.appendChild(container);
      var closeBtn = document.createElement('div');
      closeBtn.className = 'js-wrapping-select-window--close-button js-wrapping-select-window--close-trigger';
      closeBtn.textContent = 'close';
      container.appendChild(closeBtn);

      targetBox = container;
      targetCloseButton = closeBtn;
      sceneFirst = $('.block-modal-wrapping-select--first-scene', targetBox);
      sceneSecond = $('.block-modal-wrapping-select--second-scene', targetBox);
      sceneThird = $('.block-modal-wrapping-select--third-scene__some', targetBox);
      sceneThirdAll = $('.block-modal-wrapping-select--third-scene__all', targetBox);
      wrappingMessageSettingArea = $('.block-modal-wrapping-select--message-setting', targetBox);

      show(sceneFirst); hide(sceneSecond); hide(sceneThird); hide(sceneThirdAll);
      hide(wrappingMessageSettingArea);
      fadeIn(target, 400);
      boxSizeSet();

      // メッセージチェックアコーディオン
      onAll('.block-modal-wrapping-select--message-check > input[type="checkbox"]', 'click', function () {
        if (this.checked) { show(wrappingMessageSettingArea); } else { hide(wrappingMessageSettingArea); }
        boxSizeSet();
      });

      on(window, 'resize', boxSizeSet);
      on(target, 'click', modalClose);
      on(closeBtn, 'click', modalClose);
      on(targetBox, 'click', function (ev) { ev.stopPropagation(); });

      // シーン遷移
      onAll('.block-modal-wrapping-select--move-trigger__first', 'click', function () {
        fadeOut(sceneSecond, 400, function () { if (sceneSecond) $$('input[type="radio"]', sceneSecond).forEach(function (r) { r.checked = false; }); });
        fadeOut(sceneThird, 400, function () {
          if (sceneThird) { $$('input[type="checkbox"],input[type="radio"]', sceneThird).forEach(function (i) { i.checked = false; }); }
          hide(wrappingMessageSettingArea);
        });
        fadeOut(sceneThirdAll, 400, function () {
          if (sceneThirdAll) { $$('input[type="checkbox"],input[type="radio"]', sceneThirdAll).forEach(function (i) { i.checked = false; }); }
          hide(wrappingMessageSettingArea);
        });
        fadeIn(sceneFirst, 400, boxSizeSet);
      });
      onAll('.block-modal-wrapping-select--move-trigger__second', 'click', function () {
        fadeOut(sceneFirst, 400);
        fadeOut(sceneThird, 400, function () {
          if (sceneThird) $$('input[type="radio"]', sceneThird).forEach(function (r) { r.checked = false; });
          hide(wrappingMessageSettingArea);
        });
        fadeIn(sceneSecond, 400, boxSizeSet);
      });
      onAll('.block-modal-wrapping-select--move-trigger__third-some', 'click', function () {
        fadeOut(sceneSecond, 400);
        fadeIn(sceneThird, 400, boxSizeSet);
      });
      onAll('.block-modal-wrapping-select--move-trigger__third-all', 'click', function () {
        fadeOut(sceneFirst, 400);
        fadeIn(sceneThirdAll, 400, boxSizeSet);
      });
    });
  }

  // =============================================
  // page-order-confirmation
  // =============================================
  function pageOrderConfirmationSet() {
    // カード選択表示切替
    (function () {
      var regPC = $('.block-confirmation--card-type-input__registered');
      var newPC = $('.block-confirmation--card-type-input__new');
      var regSP = $('.block-confirmation--payment-method-card-type-input__registered');
      var newSP = $('.block-confirmation--payment-method-card-type-input__new');
      var regArea = $('.block-confirmation--card-registered-list');
      var newArea = $('.block-confirmation--card-new-area');
      if (newArea) hide(newArea);

      function onReg() { hide(newArea); show(regArea); }
      function onNew() {
        hide(regArea);
        if (regArea) $$('input[type="radio"]', regArea).forEach(function (r) { r.checked = false; });
        show(newArea);
      }
      on(regPC, 'change', function () { if (this.checked) onReg(); });
      on(newPC, 'change', function () { if (this.checked) onNew(); });
      on(regSP, 'change', function () { if (this.checked) onReg(); });
      on(newSP, 'change', function () { if (this.checked) onNew(); });
    })();

    // お届け先選択モーダル
    (function () {
      var target, targetBox, targetCloseButton;
      var newArea, editArea;

      function boxSizeSet() {
        var wh = outerHeight(target); var bh = outerHeight(targetBox);
        var ww = outerWidth(target); var bw = outerWidth(targetBox);
        targetBox.style.top = ((wh - bh) / 2) + 'px';
        targetBox.style.left = ((ww - bw) / 2) + 'px';
      }
      function modalClose() {
        fadeOut(target, 400, function () {
          if (targetBox && targetBox.parentNode) {
            while (targetBox.firstChild) targetBox.parentNode.insertBefore(targetBox.firstChild, targetBox);
            targetBox.parentNode.removeChild(targetBox);
          }
          if (targetCloseButton && targetCloseButton.parentNode) targetCloseButton.parentNode.removeChild(targetCloseButton);
          hide(newArea); hide(editArea);
        });
      }

      hideAll('.js-address-select-window');
      onAll('.js-address-select-trigger', 'click', function (e) {
        e.preventDefault();
        target = $('.js-address-select-window');
        if (!target) return;

        var container = document.createElement('div');
        container.className = 'js-address-select-window--main-container';
        while (target.firstChild) container.appendChild(target.firstChild);
        target.appendChild(container);
        var closeBtn = document.createElement('div');
        closeBtn.className = 'js-address-select-window--close-button js-address-select-window--close-trigger';
        closeBtn.textContent = 'close';
        container.appendChild(closeBtn);

        targetBox = container;
        targetCloseButton = closeBtn;
        newArea = $('.block-modal-address-select--new-area', targetBox);
        editArea = $('.block-modal-address-select--edit-area', targetBox);

        hide(newArea); hide(editArea);
        fadeIn(target, 400);
        boxSizeSet();

        on(window, 'resize', boxSizeSet);
        on(target, 'click', modalClose);
        on(closeBtn, 'click', modalClose);
        on(targetBox, 'click', function (ev) { ev.stopPropagation(); });

        onAll('.block-modal-address-select--new-button', 'click', function () {
          hide(editArea); show(newArea); boxSizeSet();
        });
        onAll('.block-modal-address-select--address-edit-trigger', 'click', function () {
          hide(newArea); show(editArea); boxSizeSet();
        });
      });
    })();
  }

  // =============================================
  // page-license-check
  // =============================================
  function pageLicenseCheckSet() {
    var checks = $$('.block-license-check--question-check');
    var nextBtn = $('.block-license-check--next-button');

    function checkerReset() {
      checks.forEach(function (c) { c.checked = false; });
      if (nextBtn) nextBtn.disabled = true;
    }
    checkerReset();

    checks.forEach(function (c) {
      on(c, 'click', function () {
        var checkedCount = $$('.block-license-check--question-check').filter(function (cb) { return cb.checked; }).length;
        if (checkedCount > 2 && nextBtn) nextBtn.disabled = false;
      });
    });
    onAll('.block-license-check--reset-button', 'click', checkerReset);
  }

}(window));

(function (window) {
  "use strict";
  var bp = 736;

  // ユーティリティ
  function getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }
  function getWindowHeight() {
    return window.innerHeight;
  }
  function getWindowWidth() {
    return window.innerWidth;
  }
  function getDocumentHeight() {
    return document.documentElement.scrollHeight;
  }

  // fadeIn（ガード付き）
  function fadeIn(el, duration, callback) {
    if (!el) return;
    // 既にフェードイン中、または表示済みならスキップ
    if (el._fadingIn) return;
    if (el.style.display !== 'none' && parseFloat(el.style.opacity) === 1) return;

    duration = duration || 400;

    // 実行中のfadeOutがあればキャンセル
    if (el._fadeAnimId) {
      cancelAnimationFrame(el._fadeAnimId);
      el._fadeAnimId = null;
    }

    el._fadingIn = true;
    el._fadingOut = false;

    var startOpacity = parseFloat(el.style.opacity) || 0;
    if (el.style.display === 'none' || getComputedStyle(el).display === 'none') {
      el.style.display = 'block';
      startOpacity = 0;
    }
    el.style.opacity = startOpacity;

    var start = null;
    var remaining = (1 - startOpacity) * duration;

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / remaining, 1);
      el.style.opacity = startOpacity + (1 - startOpacity) * progress;
      if (progress < 1) {
        el._fadeAnimId = requestAnimationFrame(step);
      } else {
        el.style.opacity = 1;
        el._fadingIn = false;
        el._fadeAnimId = null;
        if (callback) callback();
      }
    }
    el._fadeAnimId = requestAnimationFrame(step);
  }

  // fadeOut（ガード付き）
  function fadeOut(el, duration, callback) {
    if (!el) return;
    // 既にフェードアウト中、または非表示ならスキップ
    if (el._fadingOut) return;
    if (el.style.display === 'none') return;
    if (getComputedStyle(el).display === 'none') return;

    duration = duration || 400;

    // 実行中のfadeInがあればキャンセル
    if (el._fadeAnimId) {
      cancelAnimationFrame(el._fadeAnimId);
      el._fadeAnimId = null;
    }

    el._fadingOut = true;
    el._fadingIn = false;

    var startOpacity = parseFloat(el.style.opacity);
    if (isNaN(startOpacity)) startOpacity = 1;

    var start = null;
    var remaining = startOpacity * duration;
    if (remaining <= 0) {
      el.style.display = 'none';
      el.style.opacity = 0;
      el._fadingOut = false;
      if (callback) callback();
      return;
    }

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / remaining, 1);
      el.style.opacity = startOpacity * (1 - progress);
      if (progress < 1) {
        el._fadeAnimId = requestAnimationFrame(step);
      } else {
        el.style.display = 'none';
        el.style.opacity = 0;
        el._fadingOut = false;
        el._fadeAnimId = null;
        if (callback) callback();
      }
    }
    el._fadeAnimId = requestAnimationFrame(step);
  }

  // slideDown（display:none でも高さを正しく取得）
  function slideDown(el, duration) {
    if (!el) return;
    if (el._sliding) return;
    el._sliding = true;
    duration = duration || 400;

    // 高さを正しく測るため一瞬表示
    el.style.display = '';
    el.style.visibility = 'hidden';
    el.style.position = 'absolute';
    el.style.height = '';
    var h = el.scrollHeight;
    el.style.visibility = '';
    el.style.position = '';

    el.style.overflow = 'hidden';
    el.style.height = '0px';
    el.style.display = 'block';

    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      el.style.height = (h * progress) + 'px';
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.style.height = '';
        el.style.overflow = '';
        el._sliding = false;
      }
    }
    requestAnimationFrame(step);
  }

  // slideUp
  function slideUp(el, duration) {
    if (!el) return;
    if (el._sliding) return;
    el._sliding = true;
    duration = duration || 400;

    el.style.overflow = 'hidden';
    var h = el.offsetHeight;
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      el.style.height = (h * (1 - progress)) + 'px';
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.style.display = 'none';
        el.style.height = '';
        el.style.overflow = '';
        el._sliding = false;
      }
    }
    requestAnimationFrame(step);
  }

  // slideToggle
  function slideToggle(el, duration) {
    if (!el) return;
    if (el.offsetHeight === 0 || getComputedStyle(el).display === 'none') {
      slideDown(el, duration);
    } else {
      slideUp(el, duration);
    }
  }

  // --- イベントハンドラ ---

  function onResizeScroll() {
    var wh = getWindowHeight();
    var scrollTop = getScrollTop();
    var current050 = scrollTop + wh * 0.5;
    var current080 = scrollTop + wh * 0.8;
    var viewBottom = scrollTop + wh;

    // 表示判定（区間）
    document.querySelectorAll('.inview-repeat').forEach(function (el) {
      var targetStart = el.getBoundingClientRect().top + scrollTop;
      var targetEnd = targetStart + el.offsetHeight;
      if (targetStart < current050 && current050 < targetEnd) {
        el.classList.add('inview-repeat-active');
      }
      if (targetEnd + wh < current050) {
        el.classList.remove('inview-repeat-active');
      }
      if (viewBottom < targetStart) {
        el.classList.remove('inview-repeat-active');
      }
    });

    // 表示判定（1回のみ）
    document.querySelectorAll('.inview').forEach(function (el) {
      var targetStart = el.getBoundingClientRect().top + scrollTop;
      if (targetStart < current080) {
        el.classList.add('inview-active');
      }
    });

    // about-content 背景画像変更
    if (document.getElementById('about-content')) {
      var target = getDocumentHeight() / 2;
      var bgImg = document.querySelector('.background-image');
      if (bgImg) {
        if (target < current050) {
          fadeIn(bgImg, 1000);
        } else {
          fadeOut(bgImg, 1000);
        }
      }
    }

    // about-top パララックス処理
    if (document.getElementById('about-top')) {
      var current = scrollTop + wh;

      document.querySelectorAll('.content-wrap .background-image').forEach(function (el) {
        var targetTop = el.getBoundingClientRect().top + scrollTop;
        var targetHeight = el.offsetHeight;
        var targetWidth = el.offsetWidth;
        var startPosition = targetTop;
        var endPosition = startPosition + targetHeight + wh;
        var bgSizeRatio = 2;
        var bgMargin = Math.floor(targetHeight * (bgSizeRatio - (targetHeight / targetWidth)));
        var bgPositionY = -bgMargin + Math.floor(bgMargin * (current - targetTop) / (targetHeight + wh));
        var bgPosition = 'center ' + bgPositionY + 'px';
        if (startPosition < current && current < endPosition) {
          el.style.backgroundPosition = bgPosition;
        }
      });

      document.querySelectorAll('.content-wrap .background-image-muse').forEach(function (el) {
        var targetTop = el.getBoundingClientRect().top + scrollTop;
        var targetHeight = el.offsetHeight;
        var targetStart = targetTop;
        var targetEnd = targetTop + targetHeight + wh;
        var base = bp < getWindowWidth() ? 200 : 50;
        var bgpy = -base + Math.floor(base * (current - targetTop) / (targetHeight + wh));
        var bgp = 'center ' + bgpy + 'px';
        if (targetStart < current && current < targetEnd) {
          el.style.backgroundPosition = bgp;
        } else {
          el.style.backgroundPosition = 'center';
        }
      });
    }
  }

  function onLoadResize() {
    movieHeightSetting();

    // about-top 高さ指定 pc限定
    if (document.getElementById('about-top')) {
      var selectors = [
        '.brand-statement .content-wrap',
        '.brand-name .content-wrap',
        '.craftsmanship .content-wrap'
      ];
      if (bp < getWindowWidth()) {
        var contentHeight = getWindowHeight();
        var contentMaxHeight;
        if (1200 < getWindowWidth()) {
          contentMaxHeight = getWindowWidth() * 0.8;
        } else {
          contentMaxHeight = 1200 * 0.8;
        }
        selectors.forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            el.style.height = contentHeight + 'px';
            el.style.maxHeight = contentMaxHeight + 'px';
          });
        });
      } else {
        selectors.forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            el.style.height = 'auto';
            el.style.maxHeight = '100%';
          });
        });
      }
    }
  }

  // 動画高さ指定
  function movieHeightSetting() {
    var movieEl = document.querySelector('.movie__youtube');
    if (!movieEl) return;
    var movieWidth = movieEl.offsetWidth;
    var movieHeight = movieWidth * 0.5625;
    var movieMarginTop = (getWindowHeight() - movieHeight) / 2;
    movieEl.style.height = movieHeight + 'px';
    movieEl.style.marginTop = movieMarginTop + 'px';
  }

  // --- 初期化 ---
  window.addEventListener('resize', onResizeScroll);
  window.addEventListener('scroll', onResizeScroll);
  window.addEventListener('load', onLoadResize);
  window.addEventListener('resize', onLoadResize);

  document.addEventListener('DOMContentLoaded', function () {

    // アコーディオン
    document.querySelectorAll('.acd-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.acd-box').forEach(function (box) {
          slideToggle(box, 1000);
        });
        document.querySelectorAll('.acd-btn').forEach(function (b) {
          b.classList.toggle('active');
        });
      });
    });

    // 動画バナークリック
    document.querySelectorAll('.movie-thumbnail').forEach(function (el) {
      el.addEventListener('click', function () {
        var modal = document.querySelector('.modal-content');
        if (modal) {
          fadeIn(modal, 400);
          movieHeightSetting();
        }
      });
    });

    // モーダル（動画）背景クリック
    var modalContent = document.querySelector('.modal-content');
    if (modalContent) {
      modalContent.addEventListener('click', function () {
        fadeOut(modalContent, 400);
      });
    }

    // about-content ページ専用
    if (document.getElementById('about-content')) {
      setTimeout(function () {
        document.querySelectorAll('.copy.onload').forEach(function (el) {
          el.classList.add('onload-active');
        });
      }, 400);
      setTimeout(function () {
        document.querySelectorAll('.title.onload').forEach(function (el) {
          el.classList.add('onload-active');
        });
        document.querySelectorAll('.text-wrap.onload').forEach(function (el) {
          el.classList.add('onload-active');
        });
      }, 1800);
    }

    // about-top ページ専用
    if (document.getElementById('about-top')) {

      // オープニング処理
      var openingLogo = document.querySelector('.opening .logo');
      var openingCopy = document.querySelector('.opening .copy');
      var opening = document.querySelector('.opening');

      setTimeout(function () {
        if (openingLogo) fadeIn(openingLogo, 400);
      }, 400);

      setTimeout(function () {
        if (openingLogo) fadeOut(openingLogo, 400);
      }, 2400);

      setTimeout(function () {
        if (openingCopy) {
          var text = openingCopy.textContent;
          var chars = text.split('');
          openingCopy.innerHTML = '';
          openingCopy.style.display = 'block';
          openingCopy.style.opacity = 1;

          chars.forEach(function (char, idx) {
            var span = document.createElement('span');
            span.textContent = char;
            span.style.opacity = 0;
            span.style.display = 'inline-block';
            if (char === ' ') span.style.whiteSpace = 'pre';
            openingCopy.appendChild(span);

            setTimeout(function () {
              var start = null;
              function step(ts) {
                if (!start) start = ts;
                var progress = Math.min((ts - start) / 1100, 1);
                span.style.opacity = progress;
                if (progress < 1) requestAnimationFrame(step);
              }
              requestAnimationFrame(step);
            }, idx * 80);
          });
        }
      }, 3400);

      setTimeout(function () {
        if (opening) fadeOut(opening, 400);
      }, 7400);

      if (opening) {
        opening.addEventListener('click', function () {
          fadeOut(opening, 400);
        });
      }

      // CRUCIAL VALUES FOR THE BRAND スライド
      // ※ slick は jQuery プラグインのため、Vanilla JS 対応の
      //   スライダーライブラリへの置き換えが必要です。
      //   以下は Splide を使用する例:
      //
      // new Splide('.crucial-values__list', {
      //   type: 'loop',
      //   perPage: 1,
      //   autoplay: false,
      //   speed: 1000,
      //   focus: 'center',
      //   padding: { left: '180px', right: '180px' },
      //   arrows: true,
      //   breakpoints: {
      //     736: {
      //       padding: 0,
      //       focus: 0,
      //     },
      //   },
      // }).mount();
    }
  });

}(window));